import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { AdminFeatureManagementData, RoleManagementData, SaveAdminFeaturePermissionsRequest, SaveRoleManagementPermissionsRequest, ValidateRoleManagementPassKeyRequest, ValidateRoleManagementPassKeyResult } from '../models/role-management.model';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private apiService: ApiService) {}

  getRoleManagementData(): Observable<RoleManagementData> {
    return this.apiService.get('Admin/role-management');
  }

  saveRoleManagementPermissions(request: SaveRoleManagementPermissionsRequest): Observable<boolean> {
    return this.apiService.post('Admin/role-management', request);
  }

  validateRoleManagementPassKey(request: ValidateRoleManagementPassKeyRequest): Observable<ValidateRoleManagementPassKeyResult> {
    return this.apiService.post('Admin/role-management/validate-passkey', request);
  }

  getAdminFeatureManagementData(): Observable<AdminFeatureManagementData> {
    return this.apiService.get('Admin/admin-features');
  }

  saveAdminFeaturePermissions(request: SaveAdminFeaturePermissionsRequest): Observable<boolean> {
    return this.apiService.post('Admin/admin-features', request);
  }

  getUserAdminFeaturePermissions(): Observable<string[]> {
    return this.apiService.get('Admin/admin-features/my-permissions');
  }
}
